import { Validator } from 'projects/core/src/lib/helpers/validator';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { TimezoneService } from '../services/timezone.service';

@Pipe({
  name: 'timezoneTime',
  pure: false // performance???
})
export class TimezoneTimePipe implements PipeTransform {

  constructor(public timezone: TimezoneService) { }

  transform(value: unknown, ...args: unknown[]): moment.Moment | string {
    if (!value) {
      return '';
    }
    let timezone = null;
    if (Validator.isString(args[0], 1)) {
      timezone = args[0];
    } else {
      timezone = this.timezone.getActiveTimezone();
    }
    return (timezone !== null) ? moment(value).tz(timezone) : moment(value).local();
  }

}
